import { DataListComponent }  from './data-list/data-list.component';
import { DataGridComponent,
         DataListFilterPipe } from './data-grid/data-grid.component';

export default [
  DataListComponent,
  DataGridComponent,
  DataListFilterPipe
];



// WEBPACK FOOTER //
// ./src/app/shared/data-list/index.ts